<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="content">
            <h3 class="has-text-info">直接拖曳即區塊排序</h3>
          </div>
        </div>
      </div>
      <div class="level-right">
        <p class="level-item">
          <b-button
            type="is-primary"
            @click="updateAreas"
            :loading="loadingAreaList"
          >
            {{ $t('attributes.update') }}
          </b-button>
        </p>
      </div>
    </nav>
    <b-table
      :data="areaList"
      :loading="loadingAreaList"
      :mobile-cards="false"
      narrowed
      bordered
      draggable
      @dragstart="dragstart"
      @drop="drop"
      @dragover="dragover"
      @dragleave="dragleave"
    >
      <b-table-column
        field="promote_sort"
        :label="$t('attributes.sort')"
        width="75"
        sortable
        numeric
        centered
        v-slot="props"
      >
        {{ props.row.promote_sort }}
      </b-table-column>
      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        width="200"
        sortable
        numeric
        centered
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>
      <b-table-column
        field="is_promote"
        :label="$t('attributes.is_promote')"
        width="200"
        sortable
        numeric
        centered
        v-slot="props"
      >
        <b-select v-model="props.row.is_promote">
          <option value="true" style="color:Blue;">顯示</option>
          <option value="false" style="color:#acacac;">隱藏</option>
        </b-select>
      </b-table-column>
      <b-table-column
        field="name"
        :label="$t('attributes.is_promote') + $t('attributes.count')"
        width="200"
        sortable
        numeric
        centered
        v-slot="props"
      >
        <b-select v-model="props.row.promote_num">
          <option v-for="option in promoNumRange" :key="option" :value="option">
            {{ option }}
          </option>
        </b-select>
      </b-table-column>
    </b-table>
  </section>
</template>

<script>
import { HOME_RECENTLY_HOT_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'RecentlyHotAreaList',
  data() {
    return {
      loadingAreaList: false,
      promoNumRange: [...Array(12).keys()].map(i => i + 1),
      areaList: [],

      draggingRow: null,
      draggingRowIndex: null
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      const api = `${HOME_RECENTLY_HOT_API}/areas`
      const res = await this.axios.get(api)
      this.areaList = res.data.data
    },
    async updateAreas() {
      try {
        this.loadingAreaList = true

        const api = `${HOME_RECENTLY_HOT_API}/areas`
        const res = await this.axios.put(api, this.areaList)
        if (res.data.message === 'OK') {
          notifyService.success(this.$t('attributes.update_succeed'))
        } else {
          notifyService.update_error()
        }
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.loadingAreaList = false
      }
    },
    dragstart(payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index

      let items = [...this.areaList]

      items.splice(this.draggingRowIndex, 1)

      items.splice(droppedOnRowIndex, 0, this.draggingRow)

      this.areaList = items.map((b, idx) => {
        return { ...b, promote_sort: idx + 1 }
      })
    }
  }
}
</script>
